import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { Eyebrow, CTA, GridLines, ContentRow, ContentItem } from "@shared"
import { css, revertSlug, logTool } from "@jsUtils"

import { PageSection } from "../PageSection"

import Styles from "./banner.module.scss"

const log = logTool()

/**
 * Banner section with a large image
 * @param {object} props - React props
 */
const Banner = props => {
  const {
    color,
    theme,
    description,
    eyebrow,
    headline,
    image,
    appearance,
    link,
    buttonLabel,
    forceLeft,
    hideGrid,
    className,
    extraClasses
  } = props
  const [ready, setReady] = React.useState(false)
  const hasContent = eyebrow || buttonLabel || description

  return (
    <PageSection
      className={css(
        Styles.section,
        Styles[`theme_${theme}`],
        hasContent && Styles.hasContent,
        appearance && Styles[`appearance_${appearance}`],
        ready && Styles.ready,
        className && className
      )}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      {image ? (
        <Img
          className={css(Styles.image, extraClasses && extraClasses.image)}
          alt={image.title}
          fluid={image.fluid}
        />
      ) : (
        ""
      )}
      <div className={css(Styles.overlay, extraClasses && extraClasses.overlay)} />
      {!hideGrid ? <GridLines theme={theme} /> : null}
      <ContentRow tagname="div" gridName="quarterAuto" extraClass={Styles.contentRow}>
        <ContentItem
          gridArea={forceLeft ? "blockTwo" : "blockFourThreeOne"}
          extraClass={css(Styles.contentItem, extraClasses && extraClasses.contentItem)}
        >
          <div className={Styles.contentWrapper}>
            {eyebrow ? (
              <Eyebrow color={color} wrap={eyebrow.length > 20} className={Styles.eyebrow}>
                {eyebrow}
              </Eyebrow>
            ) : (
              ""
            )}
            {headline ? (
              description ? (
                <>
                  <h4 className={css(Styles.headline, extraClasses && extraClasses.headline)}>
                    {headline}
                  </h4>
                  <p className={css(Styles.description, extraClasses && extraClasses.description)}>
                    {description}
                  </p>
                </>
              ) : (
                <h4 className={Styles.headline}>{headline}</h4>
              )
            ) : description ? (
              <h4 className={Styles.headline}>{description}</h4>
            ) : (
              ""
            )}
            {buttonLabel ? (
              <CTA
                ready={ready}
                className={Styles.cta}
                color={color}
                to={link}
                ascope="BANNER"
                adata={{
                  content: `${buttonLabel} - ${revertSlug(link)}`
                }}
              >
                {buttonLabel}
              </CTA>
            ) : (
              ""
            )}
          </div>
        </ContentItem>
      </ContentRow>
      {/* <div className={Styles.content}>
        <div className={Styles.mainContent}>

        </div>
      </div> */}
    </PageSection>
  )
}

export default Banner
